// extracted by css-extract-rspack-plugin
export default {"root":"wfwpbyJU3ocIZ7Ov","thumb":"oKi22RxK7EA7sOmv","option":"OaGDUrA8JiovkAk3"};